module.exports = __webpack_public_path__ + "img/14.3fb12b56.png";